import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Text } from '@common-fe/common-fe';

interface Props {
  children: React.ReactNode;
}

const UploadViaQrCodeCard: React.FC<Props> = ({ children }) => {
  const { t } = useTranslation();

  return (
    <Box
      data-testid="upload-via-qr-code_wrapper"
      pad={{ horizontal: 'spacing12', bottom: 'spacing12', top: 'spacing24' }}
      background="module"
      round="container1Round"
      align="center"
    >
      {children}
      <Box width={{ max: '180px' }}>
        <Text
          data-testid="upload-via-qr-code_title"
          margin={{ top: 'spacing12' }}
          weight={700}
          textAlign="center"
        >
          {t('The document is in your hands? Scan QR code')}
        </Text>
      </Box>
      <Box width={{ max: '245px' }}>
        <Text
          data-testid="upload-via-qr-code_description"
          margin={{ top: 'spacing8' }}
          color="textSecondary"
          textAlign="center"
        >
          {t("Effortlessly upload files by simply scanning the QR code with your device's camera")}
        </Text>
      </Box>
    </Box>
  );
};

export default UploadViaQrCodeCard;
